module.exports = __webpack_public_path__ + "static/img/aboutUs.e55bde7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/aboutUs.jpg
// module id = jyQF
// module chunks = 0